var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!awesome-typescript-loader?silent=true!./report-carousel.ts"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3a1fca46\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./report-carousel.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\projects\\ArrowHead\\AH.ModelBuilder\\AH.ModelBuilder.WebClient.AspDotNetCore\\ClientApp\\components\\report-carousel\\report-carousel.vue.html"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] report-carousel.vue.html: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3a1fca46", Component.options)
  } else {
    hotAPI.reload("data-v-3a1fca46", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./ClientApp/components/report-carousel/report-carousel.vue.html
// module id = 1065
// module chunks = 0